module.exports = __webpack_public_path__ + "static/masjid-cover-small-30da913fd46391dad8bf9cdada09e777.jpg";